import { AntDesign } from '@expo/vector-icons';
import { Button, Divider, useTheme } from '@rneui/themed';
import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    ActivityIndicator,
} from 'react-native';
import Modal from 'react-native-modal';
import { ScreenSizeContext } from '../context/ScreenSizeContext';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
    subHeader: {
        backgroundColor: '#2089dc',
        textAlign: 'center',
    },
    horizontal: {
        marginBottom: 10,
    },
    horizontalText: {
        textAlign: 'center',
        fontSize: 16,
        marginVertical: 10,
        flex: 1,
    },
    vertical: {
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    modalContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainModalCloseArea: {
        alignSelf: 'flex-end',
        margin: 10,
    },
    messageArea: {
        height: 200,
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        backgroundColor: 'white',
        padding: 3,
        borderRadius: 10,
        alignSelf: 'center',
        justifyContent: 'center',
    },
});

interface Props {
    isModalVisible: boolean;
    setIsModalVisible: any;
    children: any;
}

interface ActivityProps {
    modalState: {
        isVisible: boolean;
        loading: boolean;
    };
    closeFunc: any;
    message: string;
}

export const MainModal: React.FC<Props> = ({
    isModalVisible,
    setIsModalVisible,
    children,
}) => {
    const dimensions = React.useContext(ScreenSizeContext);

    return (
        <Modal isVisible={isModalVisible} style={styles.modalContainer}>
            <View
                style={{
                    width: dimensions.window.width > 600 ? '50%' : '100%',
                }}
            >
                <TouchableOpacity
                    style={styles.mainModalCloseArea}
                    onPress={() => {
                        setIsModalVisible(!isModalVisible);
                    }}
                >
                    <AntDesign name="closecircleo" size={40} color="black" />
                </TouchableOpacity>
                {children}
            </View>
        </Modal>
    );
};

export const ActivityModal: React.FC<ActivityProps> = ({
    modalState,
    closeFunc,
    message,
}: ActivityProps) => {
    const dimensions = React.useContext(ScreenSizeContext);
    const { theme } = useTheme();
    const { t } = useTranslation();

    return (
        <Modal isVisible={modalState.isVisible} style={styles.modalContainer}>
            {modalState.loading ? (
                <ActivityIndicator />
            ) : (
                <View
                    style={{
                        width: dimensions.window.width > 600 ? '50%' : '100%',
                        backgroundColor: 'white',
                        padding: 3,
                        borderRadius: 10,
                        alignSelf: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Text
                        style={[
                            styles.subHeader,
                            { backgroundColor: theme.colors.primary },
                        ]}
                    >
                        {t('message')}
                    </Text>
                    <Divider />
                    <View style={styles.messageArea}>
                        <Text style={styles.horizontalText}>{message}</Text>
                    </View>
                    <View style={styles.horizontal}>
                        <Button title={t('close')} onPress={closeFunc} />
                    </View>
                </View>
            )}
        </Modal>
    );
};
